import React, { useState } from 'react';
import {
  MDBBtn,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter,MDBIcon
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import NoReceipts from './NoReceipts';



    const NewReceiptModal = ({ isNewReceipt, setIsNewReceipt}) => {
  

  const toggleOpen = () => setIsNewReceipt(!isNewReceipt);

  return (
    <>
      {/* <MDBBtn onClick={toggleOpen} size='sm'>Upload New</MDBBtn> */}

      <MDBBtn tag='a' color='none' className='m-1' style={{ color: '#55acee' }} onClick={toggleOpen}>
      <MDBIcon fas icon="cloud-upload-alt"  size='lg'/> Upload New
      </MDBBtn>

      <MDBModal tabIndex='-1' open={isNewReceipt} setOpen={setIsNewReceipt}>
        <MDBModalDialog centered={true} size='lg'>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>New Document</MDBModalTitle>
              <MDBBtn className='btn-close' color='none' onClick={toggleOpen}></MDBBtn>
            </MDBModalHeader>
            <MDBModalBody>
              <NoReceipts/>
            </MDBModalBody>
            <MDBModalFooter>
              <MDBBtn color='secondary' onClick={toggleOpen}>
                Close
              </MDBBtn>
              <MDBBtn>Save changes</MDBBtn>
            </MDBModalFooter>
          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>
    </>
  );
}

NewReceiptModal.propTypes = {
    isNewReceipt: PropTypes.bool,
    setIsNewReceipt: PropTypes.func,
  };
   
  export default NewReceiptModal;